import React, { createContext, useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { addNavigationBreadcrumb } from '../../config/sentry';
// import { trackPageView } from '../../utils/analytics';

export const NavigationContext = createContext();

export const NavigationProvider = ({ children, onNavigate }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [prevLocation, setPrevLocation] = useState(null);
  
  // Get analytics consent from Redux
  // const analyticsEnabled = useSelector(state => state.cookieConsent?.analyticsEnabled || false);
  const analyticsEnabled = false; // Temporarily disabled cookie consent

  // Custom navigate function
  const customNavigate = useCallback((to, options) => {
    navigate(to, options);
  }, [navigate]);

  useEffect(() => {
    if (prevLocation && onNavigate) {
      onNavigate(prevLocation, location);
    }
    
    // Add Sentry breadcrumb for navigation
    if (prevLocation) {
      addNavigationBreadcrumb(
        prevLocation.pathname + prevLocation.search,
        location.pathname + location.search
      );
    }
    
    // Track page view with analytics if consent is given
    if (analyticsEnabled && location.pathname) {
      const pageTitle = document.title || `HYK Media - ${location.pathname}`;
      // trackPageView(location.pathname, pageTitle);
    }
    
    setPrevLocation(location);
  }, [location, onNavigate, prevLocation, analyticsEnabled]);

  return (
    <NavigationContext.Provider value={{
      prev: prevLocation,
      current: location,
      navigate: customNavigate
    }}>
      {children}
    </NavigationContext.Provider>
  );
};
